const outsideOfWorkConversation = {
  id: 'outside-work',
  title: 'Life Outside of Work',
  messages: [
    "Outside of work, I’m usually falling in love with a new problem or a new story.",
    "",
    "I’ve been (slowly) writing a novel for the last few years. It’s mostly world-building right now—noodling on systems and lore that are still miles away from a first draft.",
    "",
    "My media diet leans the same way: deep fiction, complex world-building, and niche YouTube deep-dives. My TikTok, however, is pure pop-culture brain rot.",
    "",
    "I’m big on board games—it’s actually how I met my partner—and I’m a regular at trivia nights, even if my friends usually have to carry the team.",
    "",
    "I’m also an ordained minister. I’ve officiated three weddings for close friends, which probably tells you everything you need to know about how much I value my relationships.",
    "",
    "I barely post on social media; I’d much rather grab dinner or FaceTime than catch up via an Instagram story.",
    "",
    "Ideally, I’m somewhere new, traveling, people-watching, and swapping stories over a long meal that lingers for hours."
  ]
};

export default outsideOfWorkConversation;

